import { useForm } from 'react-hook-form';

import type { FormData } from '../types';

type Props = {
  values?: FormData;
};

export const useCareerMotivationModalPresenter = ({ values }: Props) => {
  const { handleSubmit, register, watch } = useForm<FormData>({
    defaultValues: values ?? { careerMotivation: '' },
  });

  const isSubmittable = !!watch('careerMotivation');

  return {
    register,
    handleSubmit,
    isSubmittable,
  };
};
